import { create } from 'zustand';
import type { PortalPassenger } from '../api/portal';

interface PortalState {
  passenger: PortalPassenger | null;
  token: string | null;
  isAuthenticated: boolean;

  setSession: (passenger: PortalPassenger, token: string) => void;
  setPassenger: (passenger: PortalPassenger) => void;
  logout: () => void;
}

export const usePortalStore = create<PortalState>((set) => ({
  passenger: null,
  token: localStorage.getItem('portalToken'),
  isAuthenticated: !!localStorage.getItem('portalToken'),

  setSession: (passenger, token) => {
    localStorage.setItem('portalToken', token);
    set({ passenger, token, isAuthenticated: true });
  },

  setPassenger: (passenger) => set({ passenger }),

  logout: () => {
    localStorage.removeItem('portalToken');
    set({ passenger: null, token: null, isAuthenticated: false });
  },
}));
